import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	Collapse,
	Nav,
	NavItem,
	Navbar,
	NavbarToggler,
	// DropdownItem,
	// DropdownMenu,
	// DropdownToggle,
	// NavLink,
	// NavbarBrand,
	// UncontrolledDropdown,
} from 'reactstrap';

import './header.css';

const activeStyle = {
	color: '#007bff',
};

class Header extends Component {
	state = {
		isOpen: false,
	};

	toggle(flag) {
		this.setState({
			isOpen: flag !== undefined ? flag : !this.state.isOpen,
		});
	}

	render() {
		const { location } = this.props;
		return (
			<Navbar dark expand="lg" className="NavBar">
				<NavbarToggler onClick={() => this.toggle()} />
				<Collapse isOpen={this.state.isOpen} navbar>
					<Nav className="ml-auto headerUL mr-auto" navbar style={{ fontSize: '1.25rem', color: 'white' }}>
						<NavItem className="d-flex align-items-center">
							<NavLink
								to="/"
								className="nav-link nav-link2 d-flex"
								isActive={() => location.pathname === '/'}
								activeStyle={activeStyle}
								onClick={() => this.toggle(false)}
							>
								Home
							</NavLink>
						</NavItem>
						<NavItem className="d-flex align-items-center">
							<NavLink
								to="/projects"
								className="nav-link nav-link2 d-flex"
								isActive={() => location.pathname === '/projects'}
								activeStyle={activeStyle}
								onClick={() => this.toggle(false)}
							>
								Projects
							</NavLink>
						</NavItem>
						<NavItem className="d-flex align-items-center">
							<NavLink
								to="/blogs"
								className="nav-link nav-link2 d-flex"
								isActive={() => location.pathname === '/blogs'}
								activeStyle={activeStyle}
								onClick={() => this.toggle(false)}
							>
								Blogs
							</NavLink>
						</NavItem>
					</Nav>
				</Collapse>
			</Navbar>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

export default withRouter(
	connect(
		mapStateToProps,
		null,
	)(Header),
);



// WEBPACK FOOTER //
// ./src/components/nav/Header.js